import React from 'react';

import { FormattedMessage } from 'react-intl';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';

import { useAppData } from 'src/app/data';
import { RepositoryFilters } from 'src/sections/profile/types';

import * as styles from './filters.styles';
import i18n from './profile-watching-filter.i18n';

type Props = {
  watching: string | undefined;
  onFilterChange: (filters: Partial<RepositoryFilters>) => void;
};

const WatchingFilter = (props: Props): JSX.Element | null => {
  const appData = useAppData();
  const { user } = appData;

  if (!user) {
    return null;
  }

  const { watching, onFilterChange } = props;

  const handleFilterChange = () => {
    onFilterChange({ watching: !watching ? user?.uuid : undefined });
  };

  return (
    <styles.WatchingFilterContainer>
      <CustomThemeButton
        appearance="subtle"
        isSelected={Boolean(watching)}
        onClick={handleFilterChange}
      >
        <FormattedMessage {...i18n.watchingButtonText} />
      </CustomThemeButton>
    </styles.WatchingFilterContainer>
  );
};

export default WatchingFilter;
